import type { OrderFailure } from "../protocol/orders";

/** 当前身份纪元内、绑定消息及状态下标的操作失败；不进入浏览器快照。 */
export interface OrderActionFailure {
  stateIndex: number;
  action: "select" | "more" | "not_received" | "check";
  orderRef?: string;
  error: OrderFailure;
}

export function orderActionError(error: string): OrderFailure {
  switch (error) {
    case "offline":
    case "rate_limited":
    case "needs_verification":
    case "not_accessible":
      return error;
    default:
      return "upstream_unavailable";
  }
}
